// @flow
import { useContext } from "react";
import TournamentApi from "../Tournaments/Api";

export function useSuggestedPromoCode() {
  // Первый из списка промокодов, пришедших в анонсе, который успешно пройдёт
  // валидацию

  let api = useContext(TournamentApi);

  let announcementsEntity = api.readEntity("/api/bell-tolls-items", {
    follow: "/api/notifications/viewed"
  });

  let profileEntity = api.readEntity("/api/profile");

  let code = null;

  if (
    (announcementsEntity.status !== "Resolved" &&
      announcementsEntity.value == null) ||
    (profileEntity.status !== "Resolved" && profileEntity.value == null)
  ) {
    return code;
  }

  let announcements = announcementsEntity.value.payload.data;

  enumerationOfCodes: for (let announcement of announcements) {
    if (announcement.type === "promocode") {
      let codeInfoEntity = api.readEntity(
        `/api/promo-code-info?code=${announcement.info.code}&lang=${
          profileEntity.value.locale
        }`
      );

      switch (codeInfoEntity.status) {
        case "Pending":
          break enumerationOfCodes;
        case "Resolved":
          code = announcement.info.code;
          break enumerationOfCodes;
        case "Rejected":
        default:
          continue enumerationOfCodes;
      }
    }
  }

  return code;
}

export function useRelevantTournamentInvitationsCount() {
  // Пересчитываем уместные приглашения в турниры среди тех, что пришли в виде
  // анонсов

  let api = useContext(TournamentApi);

  let announcementsEntity = api.readEntity("/api/bell-tolls-items", {
    follow: "/api/notifications/viewed"
  });

  let relevantInvitations = 0;

  if (announcementsEntity.value != null) {
    let announcements = announcementsEntity.value.payload.data;

    for (let announcement of announcements) {
      if (announcement.type === "invited-tournament") {
        let tournament = announcement.info;

        if (tournament.participation_status !== 1 && tournament.state < 2) {
          relevantInvitations++;
        }
      }
    }
  }

  return relevantInvitations;
}

export function useRelevantTournamentInvitations() {
  // Пересчитываем уместные приглашения в турниры среди тех, что пришли в виде
  // анонсов

  let api = useContext(TournamentApi);

  let announcementsEntity = api.readEntity("/api/bell-tolls-items", {
    follow: "/api/notifications/viewed"
  });

  let activeTournamentsEntity = api.readEntity(
    "/api/tournaments/list?status=1"
  );

  let relevantInvitations = [];

  if (
    (announcementsEntity.status !== "Resolved" &&
      announcementsEntity.value == null) ||
    (activeTournamentsEntity.status !== "Resolved" &&
      activeTournamentsEntity.value == null)
  ) {
    return relevantInvitations;
  }

  let announcements = announcementsEntity.value.payload.data;
  let activeTournaments = activeTournamentsEntity.value.items;

  for (let announcement of announcements) {
    if (announcement.type === "invited-tournament") {
      let tournament = announcement.info;

      if (
        tournament.participation_status !== 1 &&
        activeTournaments.some(t => t.id === tournament.id)
      ) {
        relevantInvitations.push(tournament);
      }
    }
  }

  const sort = (a, b) => {
    if (a > b) return 1;
    if (a < b) return -1;
  };

  return relevantInvitations.sort(sort);
}



// WEBPACK FOOTER //
// ./src/components/Bell/Labels.js